import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=77951185&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=ts&"
export * from "./MainView.vue?vue&type=script&lang=ts&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=77951185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77951185",
  null
  
)

component.options.__file = "MainView.vue"
export default component.exports